var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectionIconGreen3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59922 5.19995V24.4H26.7992V26.8H5.19922V5.19995H7.59922ZM25.9508 9.15155L27.6476 10.8484L20.7992 17.6968L17.1992 14.098L12.0476 19.2484L10.3508 17.5516L17.1992 10.7032L20.7992 14.302L25.9508 9.15155Z",
    fill: "#9A9A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59922 5.19995V24.4H26.7992V26.8H5.19922V5.19995H7.59922ZM25.9508 9.15155L27.6476 10.8484L20.7992 17.6968L17.1992 14.098L12.0476 19.2484L10.3508 17.5516L17.1992 10.7032L20.7992 14.302L25.9508 9.15155Z",
    fill: "url(#paint0_linear_740_3529)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_3529",
    x1: 16.4234,
    y1: 5.19995,
    x2: 16.4234,
    y2: 26.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionIconGreen3);
export default __webpack_public_path__ + "static/media/connection_icon_green3.c488601d0439359da6ab7ff38c3d3de8.svg";
export { ForwardRef as ReactComponent };